import React, { FC } from "react";
import ModalBoxCore from "../../core-components/modal-box/ModalBoxCore";
import ModalHeader from "../../core-components/modal-box/modal-header/ModalHeader";
import ModalBody from "../../core-components/modal-box/modal-body/ModalBody";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import ModalFooter from "../../core-components/modal-box/modal-footer/ModalFooter";
import RadioLabel from "../../core-components/radio-label/RadioLabel";
import TextField from "@mui/material/TextField";
import { iDeclineEventModalProps } from "../../../types/modalBoxType";

import "./declineEventModal.css";

const DeclineEventModal: FC<iDeclineEventModalProps> = ({
	open,
	onClose,
	modalHeaderText,
	declineModalBodyTitle,
	buttonText,
	variant,
	color,
	fullWidth,
	disabled,
	coreBtnPill,
	onclick,
	RadioGroupValue,
	RadioGroupHandleChange,
	radioLabels,
	FormControlLabelValue,
	FormControlLabelLabel,
	otherOnChange,
	otherPlaceholder,
}) => {
	return (
		<>
			<ModalBoxCore
				open={open}
				onClose={onClose}
				className="declineEventModal">
				<ModalHeader
					modalHeaderText={modalHeaderText}
					closeModal={onClose}
				/>
				<ModalBody>
					<Typography variant="body1">
						{declineModalBodyTitle}
					</Typography>
					<FormControl className="declineRadioGroup">
						<RadioGroup
							aria-labelledby="demo-controlled-radio-buttons-group"
							name="controlled-radio-buttons-group"
							value={RadioGroupValue}
							onChange={RadioGroupHandleChange}>
							{radioLabels &&
								radioLabels.map((radio, index) => (
									<RadioLabel
										key={index}
										FormControlLabelValue={
											radio.FormControlLabelValue
										}
										FormControlLabelLabel={
											radio.FormControlLabelLabel
										}
									/>
								))}
						</RadioGroup>
						{RadioGroupValue === "other" && (
							<TextField
								id="outlined-basic"
								type="text"
								onChange={otherOnChange}
								placeholder={otherPlaceholder}
								variant="outlined"
								fullWidth
								className="otherFiled"
							/>
						)}
					</FormControl>
				</ModalBody>
				<ModalFooter
					buttonText={buttonText}
					variant={variant}
					color={color}
					fullWidth={fullWidth}
					disabled={disabled}
					coreBtnPill={coreBtnPill}
					onclick={onclick}
				/>
			</ModalBoxCore>
		</>
	);
};
export default DeclineEventModal;
